import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { DesignedConfirmDialog } from 'components';
import { UngroupIcon } from 'components/CustomSVG';
import { updateCustomerPushCartApi } from 'api';
import { useStyles } from '../styles';


const UngroupQuotePlanSeriesButton = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);

  const {
    quotePlan,
    quotePlanSelectedSeriesIds,
    customerPushCart,
    currentQuoteCustomer
  } = useSelector((state: IReduxState) => state.quote);

  const selectedSeries = quotePlan.filter((series) => quotePlanSelectedSeriesIds.includes(series._id)) ;
  const isEnabled = selectedSeries.length === 1 && selectedSeries[0].selectedItems.length > 1;

  const handleUngroupSeries = async () => {
    const updatedQuotePlan = quotePlan.reduce((acc, series) => {
      if (series._id == selectedSeries[0]._id) {
        const newSeries = series.selectedItems.map((item, index) => ({
          _id: item._id,
          name: `${series.name} ${index + 1}`,
          startDate: series.startDate,
          expirationDate: series.expirationDate,
          mustUsedDate: series.mustUsedDate,
          selectedItemIds: [item._id],
          selectedItems: [item]
        }));

        return [...acc, ...newSeries];
      }

      return [...acc, series];
    }, []);

    const updatedPushCart = {...customerPushCart, customer: currentQuoteCustomer, treatments: updatedQuotePlan };
    await updateCustomerPushCartApi({ dispatch, pushCartId: customerPushCart._id, pushCart: updatedPushCart });
    setOpenConfirmModal(false);
  };

  return (
    <div className={`${!isEnabled ? 'cursor-not-allowed' : ''}`}>
      <Button
        variant="outlined"
        className={`${classes.quoteCTAButton} mr-2`}
        disabled={!isEnabled}
        onClick={() => setOpenConfirmModal(true)}
      >
        <UngroupIcon className="mr-1" muted={!isEnabled} />
        Ungroup
      </Button>
      <DesignedConfirmDialog
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        onConfirm={handleUngroupSeries}
      >
        {'Are you sure you want to ungroup '}
        <strong>{selectedSeries?.name}</strong>
        {'?'}
      </DesignedConfirmDialog>
    </div>
  );
};

export default UngroupQuotePlanSeriesButton;
